export interface RepresentativeStatusModel {
  id: RepresentativeStatusEnum;
  description: string;
}

export enum RepresentativeStatusEnum {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
}
